import { NewSupportMessageScreen } from '@/components/supportThread/NewSupportMessageScreen';
import { useOpenSupportThread } from '@/hooks/conversations/useOpenSupportThread';

export default function NewSupportMessageRoute() {
  const { open, pendingMemberId } = useOpenSupportThread();

  return (
    <NewSupportMessageScreen onSelect={(user) => open(user.id)} pendingUserId={pendingMemberId} />
  );
}
